module.exports = __webpack_public_path__ + "img/sms-email-big.37e36938.svg";